import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CapturedImage } from '@ecosystem/newron-design-system/build/export-utils/captureImage';

type ExportImagesState = Record<number, Record<string, CapturedImage>>;

const initialState: ExportImagesState = {};

const exportImagesSlice = createSlice({
  name: 'exportImages',
  initialState,
  reducers: {
    setExportImage: (
      state,
      action: PayloadAction<{
        pageType: number;
        imageKey: string;
        newImage: CapturedImage;
      }>,
    ) => {
      const { pageType, imageKey, newImage } = action.payload;
      const prev = state[pageType]?.[imageKey];
      if (prev === newImage) return;

      state[pageType] ??= {};
      state[pageType][imageKey] = newImage;
    },
    clearExportImages: (state, action: PayloadAction<number>) => {
      delete state[action.payload];
    },
  },
});

export const { setExportImage, clearExportImages } = exportImagesSlice.actions;
export default exportImagesSlice.reducer;
